<div
  class="message"
  [class.error]="isError"
  aria-live="polite"
>
  @switch (messageType) {
    @case (IconMessageTheme.Alert) {
      <mat-icon class="icon icon-color-danger" aria-label="Alert">error</mat-icon>
    }
    @case (IconMessageTheme.Error) {
      <mat-icon class="icon icon-color-danger" aria-label="Error">error</mat-icon>
    }
    @case (IconMessageTheme.Info) {
      <mat-icon class="icon icon-color-success" aria-label="Info">check_circle</mat-icon>
    }
  }

  <div>
    @if (message) {
      <span>{{message}}</span>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</div>
